import type { PageType } from 'root/widgets/types';

enum UrlMatchVariants {
  Exact = 'exact',
  Include = 'include',
  Regex = 'regex',
}

/**
 * Helper to get the PageTypes,
 * For example '/property-for-sale' is 'Listing Search' pageTypes.
 * It first get all the lists urlPageTypesMapping from config repo,
 * and search for the pageTypes from the document.referrer we currently have.
 *
 * @param url - url string
 * @param pageTypes - pageTypes Mapping from config
 * @param author - author text based on locale
 * @returns encodedObject
 */
export const getOriginPageType = (url: string, pageTypes: Array<PageType>): string => {
  if (pageTypes.length === 0 || url.length === 0) {
    return '';
  }

  const path = decodeURI(new URL(url).pathname);

  const originPageResult: string =
    pageTypes.find((item) => {
      switch (item.match) {
        case UrlMatchVariants.Exact:
          return path === item.path;
        case UrlMatchVariants.Include:
          return path.includes(item.path);
        case UrlMatchVariants.Regex:
          return path.match(item.path);
        default:
          return false;
      }
    })?.originPage || '';

  return originPageResult || '';
};
